import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import {LanguageService} from "../services/Language.Service";

export const languageInterceptor: HttpInterceptorFn = (req, next) => {
  const languageService = inject(LanguageService);
  const lang = languageService.currentLang; // 'en' | 'es-US' | 'es-PR'

  const cloned = req.clone({
    setHeaders: {
      'Accept-Language': lang
    }
  });

  return next(cloned);
};
